import { route as cartRoute } from "@faire/web-api--source/routes/cart";
import cartPath from "@faire/web-api--source/routes/cart";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useNextRouterContext } from "@faire/retailer/app/_lib/routing/NextRouterContext";
import { usePrefetchCart } from "@faire/retailer/features/Cart/useCart";

import { usePrefetchCartSummary } from "./useCartSummary";

export const useCartPrefetch = () => {
  const history = useHistory();
  const { prefetchActiveCart } = usePrefetchCart();
  const { prefetchActiveCartSummary } = usePrefetchCartSummary();
  const { prefetch: nextPrefetch } = useNextRouterContext();

  return useCallback(
    (href: string = cartRoute) => {
      if (history.location.pathname !== cartPath()) {
        nextPrefetch(href, { kind: PrefetchKind.FULL });
        prefetchActiveCart();
        prefetchActiveCartSummary();
      }
    },
    [
      history.location.pathname,
      nextPrefetch,
      prefetchActiveCart,
      prefetchActiveCartSummary,
    ]
  );
};
